import React, { useState, useEffect } from 'react'
import Radar from 'radar-sdk-js'
import useStoreLocatorContext from '@context/storeLocatorContext/useStoreLocatorContext'

const addCurrentLocationMarkerToMap = (map, position, setCurrentPositionMarker) => {
  if (!map) return
  const { lat, lng } = position

  const marker = Radar.ui
    .marker({
      color: '#e11f21',
    })
    .setLngLat([lng, lat])

  setCurrentPositionMarker(marker)
  marker.addTo(map)
}

const RadarCurrentMarker = () => {
  const [initialLoad, setInitialLoad] = useState(true)
  const map = useStoreLocatorContext(state => state.mapInstance)
  const currentPosition = useStoreLocatorContext(state => state.currentPosition)
  const currentPositionMarker = useStoreLocatorContext(state => state.currentPositionMarker)
  const setCurrentPositionMarker = useStoreLocatorContext(state => state.setCurrentPositionMarker)

  useEffect(() => {
    if (map?.loaded && currentPosition && !currentPositionMarker && initialLoad) {
      setInitialLoad(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, currentPosition])

  useEffect(() => {
    if (map?.loaded && currentPosition && !currentPositionMarker && !initialLoad) {
      addCurrentLocationMarkerToMap(map, currentPosition, setCurrentPositionMarker)
    } else if (currentPositionMarker && currentPosition) {
      currentPositionMarker.setLngLat(currentPosition)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, currentPosition])

  return <></>
}

export default RadarCurrentMarker
